import { sortBy } from 'lodash';
import { type AlboConfigurazioneTipoCampoDTO as RegisterRecordsFieldBO } from '../configuration/api/schemas/alboConfigurazioneTipoCampoDTO.ts';
import { type AlboConfigurazioneTipoCampoDTO as RegisterRecordsFieldFO } from '../frontoffice/api/schemas/alboConfigurazioneTipoCampoDTO.ts';

export function sortRegisterRecordsTypeField(
  records: RegisterRecordsFieldFO[] | RegisterRecordsFieldBO[],
) {
  return sortBy(records, 'ordine');
}
